import { render, staticRenderFns } from "./vime_activity_new_form.vue?vue&type=template&id=02576f06"
import script from "./vime_activity_new_form.vue?vue&type=script&lang=js"
export * from "./vime_activity_new_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports